import { Container, Title, Text, Stack, Paper, Anchor, Divider } from '@mantine/core';
import { Link } from 'react-router-dom';

export function Terms() {
  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <div>
          <Title order={1}>Terms and Conditions</Title>
          <Text c="dimmed" size="sm" mt="xs">Last Updated: 2025</Text>
        </div>

        <Paper withBorder p="lg" radius="md">
          <Stack gap="lg">
            <section>
              <Title order={3} mb="sm">1. Technology Demonstration</Title>
              <Text>
                This application ("Software") is a technology demonstration developed and
                owned by 33Bit Technologies Inc. ("Company"). Access to this Software does
                not grant any rights to the underlying technology or intellectual property.
              </Text>
            </section>

            <Divider />

            <section>
              <Title order={3} mb="sm">2. Intellectual Property Rights</Title>
              <Text mb="md">
                All intellectual property rights in and to the Software, including but not
                limited to:
              </Text>
              <Stack gap="xs" ml="md">
                <Text>• Source code and object code</Text>
                <Text>• Algorithms and methodologies</Text>
                <Text>• User interface designs</Text>
                <Text>• Documentation and specifications</Text>
                <Text>• Trade secrets and proprietary information</Text>
                <Text>• Patents, copyrights, and trademarks</Text>
              </Stack>
              <Text mt="md">
                are and shall remain the exclusive property of 33Bit Technologies, LLC.
              </Text>
            </section>

            <Divider />

            <section>
              <Title order={3} mb="sm">3. Restrictions</Title>
              <Text mb="md">You may NOT:</Text>
              <Stack gap="xs" ml="md">
                <Text>• Copy, modify, or distribute the Software or any portion thereof</Text>
                <Text>• Reverse engineer, decompile, or disassemble the Software</Text>
                <Text>• Claim ownership of any intellectual property contained in the Software</Text>
                <Text>• Use the Software for any commercial purpose without written authorization</Text>
                <Text>• Remove or alter any proprietary notices or labels</Text>
                <Text>• Transfer, sublicense, or assign any rights to the Software</Text>
              </Stack>
            </section>

            <Divider />

            <section>
              <Title order={3} mb="sm">4. No Warranty</Title>
              <Text fw={500} tt="uppercase" size="sm">
                THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NONINFRINGEMENT. IN NO EVENT
                SHALL 33BIT TECHNOLOGIES, LLC BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER
                LIABILITY ARISING FROM THE USE OF THE SOFTWARE.
              </Text>
            </section>

            <Divider />

            <section>
              <Title order={3} mb="sm">5. Limitation of Liability</Title>
              <Text fw={500} tt="uppercase" size="sm">
                IN NO EVENT SHALL 33BIT TECHNOLOGIES, LLC BE LIABLE FOR ANY INDIRECT,
                INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, REGARDLESS OF
                THE CAUSE OF ACTION OR THE ALLEGED THEORY OF LIABILITY.
              </Text>
            </section>

            <Divider />

            <section>
              <Title order={3} mb="sm">6. Governing Law</Title>
              <Text>
                These terms shall be governed by the laws of the United States and the
                State of Delaware, without regard to conflict of law principles.
              </Text>
            </section>

            <Divider />

            <section>
              <Title order={3} mb="sm">7. Contact</Title>
              <Text>
                For inquiries regarding licensing, permissions, or other matters:
              </Text>
              <Text mt="xs">
                Email: <Anchor href="mailto:info@33bit.com">info@33bit.com</Anchor>
              </Text>
            </section>
          </Stack>
        </Paper>

        <Text ta="center" c="dimmed" size="sm">
          © 2025 33Bit Technologies, LLC. All Rights Reserved.
        </Text>

        <Text ta="center" size="sm">
          <Anchor component={Link} to="/login">Back to Login</Anchor>
        </Text>
      </Stack>
    </Container>
  );
}
